import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeProvider, createTheme } from "@mui/material";
import logo from "../../assets/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useActiveContext } from "../../context";
import styles from "./styles";

const pages = ["Events", "Artists", "Contact", "About US"];

const theme = createTheme({
  palette: {
    primary: { main: "#000" },
    secondary: { main: "#f50057" },
  },
});

const getPath = (page) => {
  if (page === "Home") return "/";
  if (page === "About US") return "/about";
  return `/${page.toLowerCase()}`;
};

const ResponsiveAppBar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { isActive } = useActiveContext();

  const handleNav = (page) => {
    setDrawerOpen(false);
    navigate(getPath(page));
  };

  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="fixed">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={styles.desktopBarSx}>
              <Box sx={styles.desktopNavGroupSx}>
                {pages.slice(0, 2).map((page) => (
                  <Button key={page} onClick={() => handleNav(page)} sx={styles.navButtonSx}>
                    {page}
                  </Button>
                ))}
              </Box>

              <Box sx={styles.getLogoBoxSx(isActive, pathname)}>
                <Link to={"/"} style={{ textDecoration: "none" }}>
                  <img src={logo} alt="logo" style={{ width: "70px", height: "70px" }} />
                </Link>
              </Box>

              <Box sx={styles.desktopNavGroupSx}>
                {pages.slice(2, 4).map((page) => (
                  <Button key={page} onClick={() => handleNav(page)} sx={styles.navButtonSx}>
                    {page}
                  </Button>
                ))}
              </Box>
            </Box>

            {/* Mobile */}
            <Box sx={styles.mobileBarSx}>
              <Link to={"/"} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                <img src={logo} alt="logo" style={{ width: "50px", height: "50px" }} />
              </Link>

              <IconButton
                onClick={() => setDrawerOpen(true)}
                color="inherit"
                sx={{ position: "absolute", right: 0 }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: styles.drawerPaperSx }}
      >
        <Box sx={styles.drawerHeaderSx}>
          <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={styles.drawerNavSx}>
          {["Home", ...pages].map((page) => (
            <Button
              key={page}
              onClick={() => handleNav(page)}
              sx={styles.drawerButtonSx}
            >
              {page}
            </Button>
          ))}
        </Box>
      </Drawer>
    </ThemeProvider>
  );
};

export default ResponsiveAppBar;
